import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/shoppingcart.css';

const ShoppingCart = ({ cart = [], onCheckout, onRemoveFromCart }) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    // Log cart contents when it changes
    useEffect(() => {
        if (cart.length > 0) {
            console.log('Cart Contents:', cart);
            console.table(cart);
        } else {
            console.log('Cart is empty');
        }
    }, [cart]);

    // Calculate total price
    const total = cart.reduce((sum, item) => sum + (item.price || 0), 0);

    // Handle checkout process
    const handleCheckout = async () => {
        setIsProcessing(true);
        setErrorMessage('');
    
        const requestData = {
            cart, // Pass the full cart object
        };
    
        console.log('Starting checkout process with request data:', requestData);
    
        try {
            const response = await fetch(`${API_BASE_URL}/checkout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });
    
            console.log('Checkout response:', response);
    
            if (response.ok) {
                const data = await response.json();
                const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
    
                if (!stripePublicKey) {
                    throw new Error('Stripe public key is missing. Please check your environment configuration.');
                }
    
                const stripe = window.Stripe(stripePublicKey);
                console.log('Redirecting to Stripe checkout with session ID:', data.sessionId);
                await stripe.redirectToCheckout({ sessionId: data.sessionId });
            } else {
                const errorData = await response.json();
                console.error('Checkout failed:', errorData);
                setErrorMessage(errorData.message || 'Checkout failed. Please try again.');
            }
        } catch (error) {
            console.error('Checkout error:', error);
            setErrorMessage(error.message || 'An unexpected error occurred. Please try again.');
        } finally {
            setIsProcessing(false);
        }
    };
    
    return (
        <div className="shopping-cart">
            <h3>Shopping Cart</h3>
            {cart.length === 0 ? (
                <p>No items in cart.</p>
            ) : (
                <>
                    <ul>
                        {cart.map((item, index) => (
                            <li key={index} className="cart-item">
                                <span>
                                    {item.squareId || 'Unknown'} - ${item.price ? item.price.toFixed(2) : '0.00'}
                                </span>
                                <button
                                    className="remove-button"
                                    onClick={() => onRemoveFromCart(item)}
                                    title="Remove"
                                    disabled={isProcessing}
                                >
                                    ✕
                                </button>
                            </li>
                        ))}
                    </ul>
                    <p className="cart-total">
                        Total: ${total.toFixed(2)}
                    </p>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <button
                        className="checkout-button"
                        onClick={handleCheckout}
                        disabled={isProcessing || cart.length === 0}
                    >
                        {isProcessing ? 'Processing...' : 'Checkout'}
                    </button>
                </>
            )}
        </div>
    );
};

export default ShoppingCart;